import styled, {css} from "styled-components"
import {Caption} from "@irati/ui/src/Labels"
import {H3, Label} from "@irati/ui/src/Typography"
import {h2} from "@irati//ui/src/Typography/Heading/styles/index"
import Card from "@irati/ui/src/Layout/Card"

interface Props {
  active: boolean
}

export const Content = styled.div`
  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.desktop`
      display: flex;
      flex-direction: column;
    `}
  `}
`

export const Trigger = styled.span`
  ${({theme}) => css`
    top: ${theme.spacing.two};
    right: ${theme.spacing.two};
  `}
  position: absolute;
`

export const Title = styled(H3)`
  ${({theme}) => css`
    color: ${theme.colors.utility.ink};
  `}
`

export const Balances = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Balance = styled.div`
  display: flex;
  flex-direction: column;
  ${Label} {
    ${({theme}) => css`
      color: ${theme.colors.utility.contrast};
    `}
  }
`

export const AvailableCurrency = styled.span`
  ${h2}
  ${({theme}) => css`
    color: ${theme.colors.tertiary.g_400};
  `}
`

export const TTCurrency = styled.span`
  ${h2}
  ${({theme}) => css`
    color: ${theme.colors.tertiary.g_400};
  `}
`

export const StyledCaption = styled(Caption)`
  ${({theme}) => css`
    font-size: ${theme.spacing.two};
    color: ${theme.colors.utility.contrast};
    line-height: ${theme.spacing.three};
  `}
  margin-top: ${({theme}) => theme.spacing.two};
  margin-bottom: ${({theme}) => theme.spacing.two};
`

export const ActiveCard = styled(Card)<Props>`
  position: relative;
  cursor: pointer;
  ${({active, theme}) => {
    if(active) {
      return `border: 2px solid ${theme.colors.success};`
    } else {
      return "border: 2px solid transparent;"
    }
  }}
`

export const WalletPointsCard = styled.div`
  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.phoneLandscape`
      padding-right: ${theme.spacing.two};
    `}
    ${theme.mediaQueries.maxWidthMedia.phoneLandscape`
      padding-left: ${theme.spacing.two};
    `}
    margin-bottom: ${theme.spacing.one};
  `}
`

export const CashCard = styled.div`
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.phoneLandscape`
      padding-left: ${theme.spacing.two};
    `}
    margin-bottom: ${theme.spacing.one};
  `}
`
